import * as React from 'react';
import { GlobalNotification as GlobalNotification$1 } from './GlobalNotification.styles.js';

var GlobalNotification = function (_a) {
    var children = _a.children;
    return React.createElement(GlobalNotification$1, { role: "banner" }, children);
};

export { GlobalNotification as default };
//# sourceMappingURL=GlobalNotification.js.map
